import { ResponseError } from 'services/api/base';
import { MapToSubmenuOption } from './submenuOptions';

export type Subpage = 'locations' | 'rounds';

export const SUBPAGE_NAMES = {
  locations: 'Multi locais',
  rounds: 'Multi rodadas',
};

export const SUBPAGE_SUBMENU_OPTIONS: MapToSubmenuOption = {
  locations: 'multi-locais',
  rounds: 'multi-rodadas',
};

export const PRODUCT_TYPE = 'agro';

export type ChartType = 'line' | 'heatmap';

export interface ChartStatus {
  data: object | undefined;
  error: ResponseError | undefined;
  isFetching: boolean;
}

export type ChartData = {
  [subpage in Subpage]: {
    [chartType in ChartType]: ChartStatus;
  };
};
